export const aboutMeSkills = [
  "REACT",
  "GRAPHQL",
  "GO",
  "CSS/SCSS",
  "JAVASCRIPT",
  "OBJECTIVE-C",
  "SWIFT",
  "JAVA"
];

export const aboutMeHeader = "My skills";
